export const SECTIONS = [
  { slug: "art-gallery",    label: "Art Gallery" },
  { slug: "art-centre",     label: "Art Centre" },
  { slug: "ceramic-studio", label: "Ceramic Studio" },
  { slug: "cafe",           label: "Cafe" },
  { slug: "stage",          label: "Stage" },
  { slug: "coworking",      label: "Co-working" },
];

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      weekday: "short", day: "numeric", month: "short", year: "numeric",
      hour: "numeric", minute: "2-digit", hour12: true,
    });
  } catch { return iso; }
};

// Compact "When" line for an event card.
// - Recurring → the human recurrence label
// - Multi-day (starts and ends on different calendar dates) → "Wed 15 Oct → Sun 19 Oct 2026"
// - Single-day → the full single-datetime formatDate
export const formatEventWhen = (event) => {
  if (!event) return "";
  if (event.is_recurring && event.recurrence_label) return event.recurrence_label;
  const starts = event.starts_at ? new Date(event.starts_at) : null;
  const ends = event.ends_at ? new Date(event.ends_at) : null;
  if (starts && ends && starts.toDateString() !== ends.toDateString()) {
    const short = { weekday: "short", day: "numeric", month: "short" };
    const full = { weekday: "short", day: "numeric", month: "short", year: "numeric" };
    const sameYear = starts.getFullYear() === ends.getFullYear();
    return `${starts.toLocaleDateString("en-IN", sameYear ? short : full)} → ${ends.toLocaleDateString("en-IN", full)}`;
  }
  return formatDate(event.starts_at);
};

export const formatINR = (n) => `₹ ${Number(n || 0).toLocaleString("en-IN")}`;
